var map = {
	"./add-green.svg": "8203",
	"./add-purple.svg": "6d88",
	"./addcollection.svg": "98f8",
	"./added_collection.svg": "b2f9",
	"./ai-btn-icon.svg": "b5db",
	"./ai-chat-active-icon.svg": "06e4",
	"./ai-chat-btn-new-chat-icon.svg": "e769",
	"./ai-chat-close-icon.svg": "f197",
	"./ai-chat-cmp-plus.svg": "2b9e",
	"./ai-chat-copy-to-clipboard.svg": "7afe",
	"./ai-chat-history-active.svg": "5d27",
	"./ai-chat-history-cmp-icon.svg": "61a8",
	"./ai-chat-history-delete.svg": "fdcf",
	"./ai-chat-history-icon.svg": "1c55",
	"./ai-chat-history-inactive-icon.svg": "a66d",
	"./ai-chat-icon.svg": "49a8",
	"./ai-chat-inactive-icon.svg": "d8b9",
	"./ai-chat-send-icon.svg": "8e3e",
	"./ai-compare-history-calender.svg": "4ebe",
	"./ai-compare-history-chevron-down.svg": "80a5",
	"./ai-compare-history-chevron-left.svg": "39ac",
	"./ai-compare-history-chevron-right.svg": "0cf7",
	"./ai-compare-history-delete.svg": "341d",
	"./ai-compare-history-no-result.svg": "56b1",
	"./ai-compare-history-open-in-new.svg": "2dc7",
	"./ai-icon.svg": "9c36",
	"./alert-s.svg": "c4b0",
	"./alert.svg": "590d",
	"./arrow-down.svg": "5a5a",
	"./back.svg": "781e",
	"./banner-environmental-standards.jpg": "23a6",
	"./bookmark-yellow.svg": "70f6",
	"./bookmark.svg": "afa7",
	"./bookmarks-document.svg": "4d91",
	"./calendar-tab.svg": "ea32",
	"./cb-action-delete.svg": "6638",
	"./cb-action-dots.svg": "2711",
	"./cb-action-rename.svg": "29c8",
	"./cb-ai-avatar.svg": "c298",
	"./cb-chat.svg": "b4c2",
	"./cb-clock.svg": "36b1",
	"./cb-close.svg": "7f87",
	"./cb-collapse.svg": "f3dd",
	"./cb-copied.svg": "5772",
	"./cb-copy.svg": "73b7",
	"./cb-dislike-active.svg": "bfe2",
	"./cb-dislike.svg": "8c84",
	"./cb-expand-history.svg": "7438",
	"./cb-expand.svg": "a15f",
	"./cb-like-active.svg": "de66",
	"./cb-like.svg": "affa",
	"./cb-loading.svg": "cd56",
	"./cb-modal-close.svg": "3eb1",
	"./cb-new-chat.svg": "7dd3",
	"./cb-next-arrow.svg": "4301",
	"./cb-search-clear.svg": "710f",
	"./cb-search.svg": "a193",
	"./cb-select-collapse.svg": "5470",
	"./cb-select-expand.svg": "6885",
	"./cb-send-disabled.svg": "095b",
	"./cb-send.svg": "fe56",
	"./cb-step-list.svg": "8d44",
	"./cb-step.svg": "3928",
	"./check-circle.svg": "c439",
	"./chevron-down-purple-thick.svg": "0126",
	"./chevron-down-white.svg": "4eea",
	"./chevron-down.svg": "7433",
	"./clear-all-purple.svg": "7e10",
	"./clear-all.svg": "ce11",
	"./close.svg": "711b",
	"./cmp-chevron-left.svg": "d791",
	"./cmp-clock.svg": "5868d",
	"./cmp-close.svg": "00ad",
	"./cmp-loading-star.svg": "ef69",
	"./cmp-plus.svg": "4c32",
	"./cmp-regenerate-inactive.svg": "9825",
	"./cmp-regenerate.svg": "0a54",
	"./cmp-tab-active-history.svg": "2df7",
	"./cmp-tab-active-version.svg": "1075",
	"./cmp-tab-inactive-history.svg": "d4ee",
	"./cmp-tab-inactive-version.svg": "ce6c",
	"./cmp-toc-expand.svg": "ab20",
	"./cmp-version-option-expand.svg": "f0f7",
	"./comment.svg": "cbbe",
	"./compare-history-th-sort-icon.svg": "726f",
	"./completed.svg": "d6b7",
	"./confirmed.svg": "1b76",
	"./copy.svg": "1867",
	"./cross.svg": "6ab8",
	"./disabled.svg": "7686",
	"./document-green.svg": "876d",
	"./document-reverse.svg": "fd5e",
	"./document.svg": "f6d9",
	"./downloaded-document-active.svg": "88be",
	"./downloaded-document.svg": "b101",
	"./downloaded-user-active.svg": "18c1",
	"./downloaded-user.svg": "4b63",
	"./downloaded.svg": "bd66",
	"./downloading.svg": "4078",
	"./error.svg": "8c98",
	"./expired.svg": "2ba8",
	"./eye.svg": "7ed1",
	"./faq-accordion-down.svg": "a1fd8",
	"./faq-accordion-up.svg": "8a32",
	"./favicon.ico": "6e36",
	"./favicon.png": "cab6",
	"./file-search.svg": "7eb5",
	"./green-check.svg": "d47e",
	"./hardcopy.svg": "8d2a",
	"./highlight.svg": "b263",
	"./hint.svg": "e875",
	"./icon-bin-white.svg": "ae1c",
	"./icon-bin.svg": "21da",
	"./icon-btn-compare.svg": "d407",
	"./icon-close.svg": "1a7e",
	"./icon-compliance-hub.svg": "002a",
	"./icon-copy.svg": "fa95",
	"./icon-eurlex.svg": "d53b",
	"./icon-lawlex.svg": "2f82",
	"./icon-logicom.svg": "b873",
	"./icon-materials.svg": "1bf8",
	"./icon-metals.svg": "4491",
	"./icon-ncc.svg": "35d4",
	"./icon-pencil.svg": "8f16",
	"./icon-regenerate.svg": "a7b6",
	"./icon-standards.svg": "af26",
	"./icon-training.svg": "f1aa",
	"./import.svg": "6dab",
	"./info.svg": "e1ae",
	"./lawlex-accordion-lock.svg": "9d32",
	"./lawlex-no-data.svg": "84d2",
	"./lawlex-recent-search-icon.svg": "fddb",
	"./lawlex-regulatory-icon.svg": "f504",
	"./lawlex-user-icon.svg": "2673",
	"./lawlex_blank_1.svg": "1e66b",
	"./lawlex_lock.svg": "2457",
	"./list-bullets.svg": "bd24",
	"./lock.svg": "abac",
	"./magnifier.svg": "d2fa",
	"./materials.svg": "0f8e",
	"./messages-bubble-icon.svg": "597b",
	"./metals.svg": "bc40",
	"./minus.svg": "1ed5",
	"./move.svg": "2b33",
	"./ninedot-lock.svg": "acb0",
	"./ninedots-search-icon.svg": "9cb1",
	"./onboarding-wizard-logo.svg": "96b7",
	"./pdf.svg": "8143",
	"./purple-left-arrow.svg": "63a8",
	"./querylimit.svg": "3a81",
	"./reconfirm.svg": "c988",
	"./reject.svg": "4bf7",
	"./remove-circle.svg": "3f73",
	"./request.svg": "e868",
	"./sai-ai-btn-icon.svg": "1661",
	"./sai-home-icon.svg": "12c2",
	"./sai.svg": "fad5",
	"./saiglobal_grey.svg": "bc8b",
	"./search-icon.svg": "7d45",
	"./search-placeholder.svg": "7a0d",
	"./share-icon.svg": "6919",
	"./success-tick.svg": "1e57",
	"./thumbs-down.svg": "5b2a",
	"./thumbs-up.svg": "ec42",
	"./thumbsdown-fill.svg": "e11c",
	"./thumbsup-fill.svg": "1d1f",
	"./tooltip.svg": "fa1f",
	"./touch.svg": "b52b",
	"./unconfirmed.svg": "8bc5",
	"./unpublished.svg": "f547",
	"./user-tab.svg": "46ea",
	"./viewed-document-active.svg": "5e0f",
	"./viewed-document.svg": "9c86",
	"./viewed-user-active.svg": "538d",
	"./viewed-user.svg": "d4d9",
	"./violation.svg": "8f68",
	"./warning.svg": "a1b4",
	"./watch-icon.svg": "8a9d",
	"./white-left-arrow.svg": "dd34",
	"./white-right-arrow.svg": "3a4c",
	"./youtube.svg": "5306"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";